
import { FC } from "react";
import { IPFilter } from "./IPFilter";
import { IControlAttributes } from "../../../base/models";
import { ControlType, FetchStatus } from "../../../base/types";
import { useCookieVerification } from "../cookie/verification/useCookieVerification";
import { Registry } from "../../../base/register";
import { IPAddresseProperties } from "./useIPAddress";
import { ErrorMessage, Spinner } from "../../../widgets";
import { DraftIPAddress } from "./DraftIPAddress";

export const IPFilterComponent: FC<IControlAttributes> = ({
    children, props
}) => {
    const { status, properties, error } = useCookieVerification(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) {
        return <></>
    }

    return <IPFilter {...properties}>
        {children}
    </IPFilter>
}

Registry.addControl({
    id: "585248d5-a881-4e30-9300-9de850c9143c",
    name: "IP Filter",
    type: ControlType.IPFilterComponent,
    component: IPFilterComponent,
    properties: IPAddresseProperties,
    draftComponent: DraftIPAddress,
})
